import script from "./WebinareIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./WebinareIndex.vue?vue&type=script&setup=true&lang=js"

import "./WebinareIndex.vue?vue&type=style&index=0&id=626e96a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-626e96a8"]])

export default __exports__